import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {HttpErrorComponent} from '@core/components/http-error/http-error.component';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: true,
	imports: [RouterOutlet, HttpErrorComponent],
})
export class AppComponent {
}
